import type { FC } from "react";
import { useState } from "react";

import type { SelectedItemsView } from "pro-features/components/AutocompleteWithTabs/types";
import { FooterButton } from "pro-features/components/MultiCategoriesChipDown/src/MultiCategoryChipdownStyles";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { useDidMountEffect } from "app/custom-hooks/useDidMountEffect";

interface IApplySelection {
    selectedItemsView: SelectedItemsView;
    onApply: VoidFunction;
}

export const ApplySelection: FC<IApplySelection> = (props) => {
    const { selectedItemsView, onApply } = props;
    const selectedItemsAmount = Object.keys(selectedItemsView).length;
    const [isDisplayed, setIsDisplayed] = useState<boolean>(selectedItemsAmount > 0);
    useDidMountEffect(() => {
        setIsDisplayed(true);
    }, [selectedItemsAmount]);
    if (!isDisplayed) {
        return null;
    }
    return (
        <FooterButton
            onClick={onApply}
            data-automation="autocomplete-multi-select-apply"
        >
            <I18n>common.apply</I18n>
        </FooterButton>
    );
};
